<template>

    <li class="nav-item dropdown" :id="id+'-top-menu'" v-if="notifications">
        <a class="nav-link" href="#"  id="navbarNotifMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="material-icons">notifications</i>
            <span class="notification" v-if="notifications.length">{{ notifications.length }}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarNotifMenu">

            <a class="dropdown-item" :href="app_url + 'polaris/ui/notifications'">
                <strong>{{ lang.polaris.notification.display_all_notifications }}</strong>
            </a>

            <div class="dropdown-divider" v-if="notifications.length"></div>

            <a class="dropdown-item" href="#" v-for="notification in notifications" :key="notification.id" 
                :data-id="notification.id" @click="open(notification)">
                    {{ trans(notification.data.content.title) }}
            </a>
        </div>
    </li>

</template>

<script>
    export default {
    
        props: {
            id: { default: 'trax-notification' },
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                app_url: app_url,
                notifications: data.notifications,
                bus: this.$bus
            }
        },

        computed: {

            atpDafPermission() {
                return this.user.admin
                    // || this.user.permissions['procedure.read-atp'] || this.user.permissions['procedure.read-daf']
                    || this.user.permissions['procedure.write-atp'] || this.user.permissions['procedure.write-daf']
            }
        },

        methods: {
        
            open(notification) {
                this.bus.$emit(this.id+'-modal-open', { 
                    headerColor: 'danger',
                    icon: 'notifications',
                    title: this.trans(notification.data.content.title),
                    data: notification
                });
            },

            trans(key) {
                return this.lang.polaris.notification[key.split('.').pop()]
            }
        }
    }
</script>
